import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketing-article-item',
  templateUrl: './marketing-article-item.component.html',
  styleUrls: ['./marketing-article-item.component.scss'],
})
export class MarketingArticleItemComponent {
  @Input() data: any;
}
